
import { IImage, ImageCrops } from "@/types/types";

export function buildImageUrls(image : IImage) {
  let urls = {} as ImageCrops;
  let crops = image.crops
  for (let alias in crops) {
    let crop = crops[alias];
    let url = image.url;
    url += `?`;    
    let focalPoint = image.focalPoint;
    let coordinates = crop.coordinates;
    if(coordinates) {      
      url += `cc=${coordinates.x1},${coordinates.y1},${coordinates.y2},${coordinates.y2}&`;
    }
    if (focalPoint) {
      let left = focalPoint.left;
      let top = focalPoint.top;
      url += `rxy=${left},${top}&`;
    }
    url += `width=${crop.width}&height=${crop.height}&`;  
      // ADD the format
      url += `format=webp&quality=90&autoorient=true`;
      // Add the URL to the URLs object
      urls[crop.alias] = url;
    }    
    return urls;
  }
  